import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowLeft = (props) => (
  <Icon viewBox="0 0 6 9" {...props}>
    <g>
      <title>Path 2</title>
      <path d="M5.122 0L1 4.365l4.122 4.234" stroke="currentColor" fill="none" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowLeft;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowLeft.js